import type { RegisterDialog, RegisterDialogData } from '../../../types/helsenorge.helseregistre.internalapi.entities.entities';
import { RegisterDialogType } from '../../../types/helsenorge.helseregistre.internalapi.entities.enums';
import type { HNHelseregistreJS } from '../../../types/Resources';

export const getInnsynDialogTyper = (registerDialog: RegisterDialog | null): RegisterDialog | null => {
  if (registerDialog && registerDialog.dialogTypes) {
    const filteredDialogTypes = registerDialog.dialogTypes.filter(d => d.erInnsyn);
    return {
      ...registerDialog,
      dialogTypes: filteredDialogTypes,
    };
  }

  return registerDialog;
};
export const getHashForInnsynDialogType = (dialogTyper?: Array<RegisterDialogData> | null): string | undefined | null => {
  if (dialogTyper) {
    return dialogTyper
      .map((rd: RegisterDialogData) => {
        return rd.controlHash;
      })
      .find(d => !!d);
  }

  return undefined;
};

export const getRegisterDialogTypeForMeldeFeil = (
  registerDialogtyper: RegisterDialog | null | undefined
): RegisterDialogData | undefined | null => {
  return (
    registerDialogtyper &&
    registerDialogtyper.dialogTypes &&
    registerDialogtyper.dialogTypes.find((dialogType: RegisterDialogData) => {
      return dialogType.dialogType === RegisterDialogType.RegisterMeldeFeil && dialogType.controlHash;
    })
  );
};

export const getDialogTypeBeskrivelse = (registerDialogType: RegisterDialogType, resources: HNHelseregistreJS): string | undefined => {
  switch (registerDialogType) {
    case RegisterDialogType.RegisterInnsynOpplysninger:
      return resources.bestillInnsynLightBoxDialog1;
    case RegisterDialogType.RegisterInnsynUtlevering:
      return resources.bestillInnsynLightBoxDialog2;
    case RegisterDialogType.RegisterLoggOverBruk:
      return resources.bestillInnsynLightBoxDialog3;
    case RegisterDialogType.RegisterMeldeFeil:
      return resources.bestillInnsynLightBoxDialog4;
    default:
      return undefined;
  }
};

export const harApenDialog = (dialogTyper: RegisterDialog): boolean => {
  return !!dialogTyper && !!dialogTyper.dialogTypes && dialogTyper.dialogTypes.filter(e => !e.blokkert).length > 0;
};
